import React, { useEffect, useState } from 'react';
import { loadable } from '@shared/core/loadableFromNamedExport';
import type { UploadWidgetModalProps } from './UploadWidgetModal';

// Code-split the new upload widget (and its heavy deps — the Dropbox/Facebook browsers and the
// react-image-crop editor) into its own chunk, fetched only when the widget is first opened. Without
// this the modal rides along in every `useImageUpload`/PhotoPickerDialog consumer's bundle even when the
// `joyUploadWidgetEnabled` flag is off. Mirrors UploadFromMobileDialog.lazy.tsx.
const LazyUploadWidgetModalInner = loadable(() => import(/* webpackChunkName: "shared/UploadWidgetModal" */ './UploadWidgetModal'), 'UploadWidgetModal');

// Defer the chunk fetch until the modal is first opened. Without the `isInitialized` gate the lazy
// component triggers `import()` as soon as it renders (even with `isOpen=false`), defeating the split.
export const LazyUploadWidgetModal = (props: UploadWidgetModalProps) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (props.isOpen) setIsInitialized(true);
  }, [props.isOpen]);

  if (!isInitialized) return null;
  return <LazyUploadWidgetModalInner {...props} />;
};
